<template>
  <!--1好课 -->
  <div class="course-section" @click="go_course(dataItem)">
    <img :src="dataItem.cover_img" class="course-section-img"/>
    <div class="course-section-content">
      <div class="course-section-content-title">{{ dataItem.title }}</div>
      <div class="course-section-content-detail" v-if="dataItem.type == 2">
        共{{ dataItem.total_count }}节
        {{ dataItem.view_count }}人观看</div>
      <div class="course-section-content-detail" v-else>
        {{ dataItem.created_at ? (dataItem.created_at | formatDate('Y-M-D h:m')) : ""}}
        {{ dataItem.view_count }}人观看
      </div>
    </div>
  </div>
</template>

<script>
import Interface from '@/util/interface'
export default {
  name: "course",
  props: {
    dataItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      applyShow: false
    }
  },
  methods: {
    go_course(row) {
      if (row.type == 2) {
        this.$router.push({ name: 'course-column', params: { id: row.origin_id } })
      } else {
        this.$router.push({ name: 'course-detail', params: { id: row.origin_id } })
      }
      Interface.mFootPrint(row.origin_id,1,0,5,0, row.title)
    }
  }
}
</script>

<style scoped lang="scss">
.course-section{
  padding-bottom: 16px;
  &-img{
    width: 100%;
    height: 102px;
    background: linear-gradient(180deg, #ECEFF6 0%, #D7DFF3 100%);
    border-radius: 6px;
  }
  .van-image__img{
    width: 180px;
    height: 102px;
    border-radius: 6px;
  }
  &-content{
    height: 62px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 12px 0 0 0;
    &-title{
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    &-detail{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #979797;
      &-btn{
        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #D81D20;
        padding: 3px 7px;
        background: #FFF0EE;
        border-radius: 17px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/horizontalRecommend/course.vue